import { useAuth } from '../../context/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAuth: boolean;
}

export function ProtectedRoute({ children, requireAuth }: ProtectedRouteProps) {
  const auth = useAuth();
  const location = useLocation();

  // Add loading check
  if (auth.loading) {
    return null; // or a loading spinner component
  }

  if (requireAuth && auth.validationUnavailable) {
    return (
      <main
        role="alert"
        style={{
          minHeight: '100vh',
          display: 'grid',
          placeItems: 'center',
          padding: '24px',
          background: '#f7f8fa',
          color: '#1f2937',
          textAlign: 'center',
        }}
      >
        <div>
          <p style={{ margin: '0 0 16px' }}>
            Session verification is temporarily unavailable. Your sign-in has been retained.
          </p>
          <button
            type="button"
            onClick={() => void auth.retryValidation()}
            style={{
              minHeight: '40px',
              padding: '8px 16px',
              border: '1px solid #1f2937',
              borderRadius: '6px',
              background: '#ffffff',
              color: '#111827',
              cursor: 'pointer',
            }}
          >
            Retry
          </button>
        </div>
      </main>
    );
  }

  // Handle non-authenticated routes (like login)
  if (!requireAuth) {
    // If user is authenticated, redirect them away from login/signup pages
    if (auth?.isAuthenticated) {
      return <Navigate to="/" replace />;
    }
    return <>{children}</>;
  }

  // Handle authenticated routes
  if (!auth?.isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
